/**
 * The branch placemark from the Figma design (node "Legends", 697:12814): a
 * rounded orange badge with a 2px white outline and a white location glyph, on
 * a tapering needle stem that plants its tip on the coordinate. Geometry is
 * lifted verbatim from the exported vector; brand orange / white are swapped
 * for design tokens.
 *
 * Anchored tip-down (`-translate-x-1/2 -translate-y-full`) so the stem's point
 * sits exactly on the marker coordinate rather than the badge's center.
 */
export function BranchPin() {
  return (
    <span className="block -translate-x-1/2 -translate-y-full">
      <svg
        width="30"
        height="52"
        viewBox="20 5 50 77"
        fill="none"
        aria-hidden="true"
        className="drop-shadow-md"
      >
        {/* Needle stem */}
        <path
          d="M42 55H48V79C48 80.6569 46.6569 82 45 82C43.3431 82 42 80.6569 42 79V55Z"
          className="fill-primary"
        />
        {/* Badge + white outline */}
        <rect x="20" y="5" width="50" height="50" rx="16" className="fill-primary" />
        <rect
          x="21"
          y="6"
          width="48"
          height="48"
          rx="15"
          className="stroke-primary-foreground"
          strokeWidth="2"
        />
        {/* Location glyph */}
        <path
          d="M45.8038 41.4607C48.2148 38.4435 53.7134 31.1309 53.7134 27.0234C53.7134 22.0417 49.6717 18 44.69 18C39.7084 18 35.6667 22.0417 35.6667 27.0234C35.6667 31.1309 41.1653 38.4435 43.5762 41.4607C44.1543 42.1798 45.2258 42.1798 45.8038 41.4607ZM44.69 24.0156C45.4877 24.0156 46.2528 24.3325 46.8168 24.8965C47.3809 25.4606 47.6978 26.2256 47.6978 27.0234C47.6978 27.8211 47.3809 28.5861 46.8168 29.1502C46.2528 29.7142 45.4877 30.0311 44.69 30.0311C43.8923 30.0311 43.1273 29.7142 42.5632 29.1502C41.9991 28.5861 41.6822 27.8211 41.6822 27.0234C41.6822 26.2256 41.9991 25.4606 42.5632 24.8965C43.1273 24.3325 43.8923 24.0156 44.69 24.0156Z"
          className="fill-primary-foreground"
        />
      </svg>
    </span>
  );
}
